import type { EmbedEvent } from "./api";

function fold(value: string): string {
  return value
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase();
}

export function matchesQuery(event: EmbedEvent, q: string): boolean {
  const needle = fold(q.trim());
  if (!needle) return true;
  const haystack = fold(
    [
      event.name,
      event.description,
      event.address_title,
      ...event.tags.map((t) => t.name),
    ]
      .filter(Boolean)
      .join(" "),
  );
  return haystack.includes(needle);
}
